export default arr => [...new Set(arr)]



// WEBPACK FOOTER //
// ./src/utils/array-uniq.js